import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, Transition as _Transition } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "content"
};
import { onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useMoves } from '@/composables/useMoves';
import HeaderBlock from './elements/HeaderBlock.vue';
import MovesWidget from './elements/MovesWidget.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MovesPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getPendingMoves } = useMoves();
        onMounted(() => {
            getCustomer();
            getPendingMoves(null, false);
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Moves",
                    border: "1"
                }),
                (!_unref(state).pendingMoves)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (n) => {
                        return _createVNode(_component_v_skeleton_loader, {
                            type: "list-item-avatar-two-line",
                            key: n,
                            class: "moves-skeleton-item"
                        });
                    }), 64))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).pendingMoves)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _cache[0] || (_cache[0] = _createElementVNode("h1", null, "My Moves", -1)),
                                _createVNode(_component_v_row, { class: "mt-0" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                (_unref(state).pendingMoves)
                                                    ? (_openBlock(), _createBlock(MovesWidget, {
                                                        key: 0,
                                                        moves: _unref(state).pendingMoves,
                                                        lite: false
                                                    }, null, 8, ["moves"]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
